// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialJobPosts = () => {
  const item = window.sessionStorage.getItem("jobPosts");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : [];
};

export const getJobPosts = createAsyncThunk(
  "jobPosts/getJobPosts",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_HR_API}jobPosts`, {
        params: { branch: obj.branch },
        headers: { Authorization: `Bearer ${obj.token}` },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const jobPostsSlice = createSlice({
  name: "jobPosts",
  initialState: {
    jobPostsData: initialJobPosts(),
    error: {},
    loading: false,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getJobPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobPosts.fulfilled, (state, action) => {
        console.log(action.payload);
        state.jobPostsData = action.payload;
        sessionStorage.setItem("jobPosts", JSON.stringify(action.payload));
        // state.bookmarks = action.payload.bookmarks
      })
      .addCase(getJobPosts.rejected, (state, action) => {
        console.log(action.payload);
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default jobPostsSlice.reducer;
